import { createAction } from 'redux-actions';
export var putEntities = createAction("@@entities/PUT");
//# sourceMappingURL=actions.js.map